import React from "react";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DoneIcon from '@mui/icons-material/Done';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import TextField from '@mui/material/TextField';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import UploadIcon from '@mui/icons-material/Upload';
import CancelIcon from '@mui/icons-material/Cancel';

import Autocomplete from '@mui/material/Autocomplete';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Style from "../../../../../styles/js/Styles";
import * as Constants from "../../../../../consts/Constants.js";
import Image from "../../../../utils/image";

import { PlaceCategory } from '../../../../../plas/map/places/categories/models';
import service from '../../../../../plas/map/places/categories/service';
import { createByteArray } from "../../../../../plas/utils";
import alerter from "../../../../alerts/alerter"

export default function PlaceCategories() {

	const theme = createTheme({
	  palette: {
	    primary: {
	      main: '#FFFFFF',
	      darker: '#FFFFFF',
	    }
	  },
	});

	const style = Style();

	const [loading, setLoading] = React.useState(true);
	const [deleting, setDeleting] = React.useState(false);
	const [saving, setSaving] = React.useState(false);
	const [categories, setCategories] = React.useState({ tree: {}, list: [], map: {}});
	const [category, setCategory] = React.useState();

	const [title, setTitle] = React.useState("");
	const [name, setName] = React.useState("");
	const [parent, setParent] = React.useState(null);

	const [imageBlob, setImageBlob] = React.useState(null);
	const inputFile = React.useRef(null)

	const onSaveClick = () => {
		if (category.id)
			update();
		else
			create();
	}

	const create = () => {
		setSaving(true);
		service.api.create(category, (response) => {
			if (response.result != null) {
				let updatedCat = response.result;

				if (updatedCat.parentId == null) {
					categories.tree[updatedCat.id] = updatedCat;
				} else {
					categories.map[updatedCat.parentId].childs.push(updatedCat);
				}
				
				updatedCat.label = updatedCat.name;
				alerter.showSuccess("Categoría agregada");
				setCategory(null);
			} else {
				alerter.showError(response.error);
			}
			setSaving(false);
		});
	}

	const update = () => {
		setSaving(true);
		service.api.update(category, (response) => {
			if (response.result != null) {
				let updatedCat = response.result;
				let currentCat = categories.map[updatedCat.id];

				if (updatedCat.parentId !== currentCat.parentId) {

					if (currentCat.parentId == null) {
						categories.tree[currentCat.id] = null;
					} else {
						categories.map[currentCat.parentId].childs = categories.map[currentCat.parentId].childs.filter((item) => item.id !== currentCat.id);
					}

					if (updatedCat.parentId == null) {
						categories.tree[updatedCat.id] = currentCat;
					} else {
						categories.map[updatedCat.parentId].childs.push(currentCat);
					}
				}

				currentCat.copySimple(updatedCat);

				alerter.showSuccess("Categoría actualizada");
			} else {
				alerter.showError(response.error);
			}
			setSaving(false);
		});
	}

	const remove = () => {
		setDeleting(true);
		service.api.delete(category.id, (response) => {
			if (response.error == null) {
				let currentCat = categories.map[category.id];

				let newCategories = { ...categories }

				newCategories.map[currentCat.id] = null
				newCategories.list = newCategories.list.filter((item) => item.id !== currentCat.id);
				if (currentCat.parentId == null) {
					newCategories.tree = newCategories.tree.filter((item) => item.id !== currentCat.id);
				} else {
					newCategories.tree[currentCat.parentId].childs = newCategories.tree[currentCat.parentId].childs.filter((item) => item.id !== currentCat.id);
				}
				
				alerter.showSuccess("Categoría eliminada");
				setCategory(null);
				setCategories(newCategories)
			} else {
				alerter.showError(response.error);
			}
			setDeleting(false);
		});
	}

	const onNewClick = () => {
		let newCategory = new PlaceCategory();
		newCategory.name = "Nueva categoría";
		newCategory.descriptor = "new_category";
		newCategory.defaultImage = false;
		newCategory.iconData = null;

		setImageBlob(null);
		setCategory(newCategory);
		setName(newCategory.descriptor);
		setTitle(newCategory.name);
		setParent(null);
	}

	const onChangeTitle = (e) => {
		category.name = e.target.value.trim();
		setTitle(e.target.value);
	}

	const onChangeName = (e) => {
		category.descriptor = e.target.value.trim();
		setName(category.descriptor);
	}

	const onChangeParent = (e, newValue) => {
		if (newValue) {
			category.parentId = newValue.id;
		} else {
			category.parentId = null;
		}
		setParent(newValue);
	
	}

	const imageButtonClick = () => {
	    inputFile.current.click();
	}

  	const onSelectFile = (event) => {
	    event.stopPropagation();
	    event.preventDefault();

	    var file = event.target.files[0];

	    if (file) {
			let url = URL.createObjectURL(file);
			let newCategory = new PlaceCategory(category);
			newCategory.iconData = {
					name: file.name,
					type: file.type,
					data: createByteArray(url)
			}
			setImageBlob(url);
			setCategory(newCategory)
	    }
	}

	const cleanImage = () => {
		let newCategory = new PlaceCategory(category);
		newCategory.defaultImage = false
		newCategory.iconId = null;
		newCategory.iconData = null;
		setCategory(newCategory);
	}

	const select = (item) => {
		let cleanItem = new PlaceCategory();
		cleanItem.copySimple(item);
		cleanItem.defaultImage = true;
		setImageBlob(null);
		setCategory(cleanItem);
		setName(cleanItem.descriptor);
		setTitle(cleanItem.name);
		setParent(cleanItem.parentId ? categories.map[cleanItem.parentId] : null);
	}

	const prepareData = (categories) => {
		let rootCategories = [];

		let map = {};

		categories.forEach((category) => {
			category.label = category.name;
			map[category.id] = category;
			if (!category.parentId) {
				rootCategories.push(category);
			}
		});

		categories.forEach((category) => {
			if (category.parentId) {
				map[category.parentId].childs.push(category);
			}
		})

		setCategories({tree: rootCategories, map: map, list: categories});
	}

	const loadCategories = () => {
		service.api.getAll((response) => {
			if (response.error != null) {
        		alerter.showError(response.error);
			} else {
				prepareData(response.result);
				setLoading(false);
			}
		});
	}

	const renderTree = (item) => (
	    <TreeItem 
	    	key={item.id} 
	    	nodeId={item.id.toString()} 
	    	label={item.name}
	    	onClick={() => { select(item) }}>
	      	{ Array.isArray(item.childs) ? (
	      		item.childs.map((node) => renderTree(node))
	      	) : (
	      		null
	      	)}
	    </TreeItem>
	);

	React.useEffect(() => {
		loadCategories()
	}, []);


  	const ColoredLine = ({ color, marginBottom }) => (
	    <hr
	        style={{
	            color: color,
	            backgroundColor: color,
	            marginTop: 6,
	            marginBottom: marginBottom ? marginBottom : 16,
	            height: 2
	        }}
	    />
	);

	return(
   		<div>
			{ loading ? (
		        <div style={{color:Constants.COLOR_PRIMARY}}>
		        	<CircularProgress color="inherit" />
		        </div>
	        ):( 
	          	<Grid container>
	             	<Grid item xs={false} md={2} />
	             	<Grid item xs={12} md={8}>
	             		<Grid container spacing={2}>
							<Grid item xs={12}>
							  	<Grid container spacing={2}>
						 			<Grid item xs={true}>
					                  <p style={{ fontSize: '28px', textAlign: 'left'}}>
					                    Categorias
					                  </p>
					                </Grid>
					                <Grid item>
					                  <ThemeProvider theme={theme}>
					                    <Button
					                      startIcon={<AddRoundedIcon />}
					                      variant="contained"
					                      onClick={onNewClick}>
					                      <b>Agregar</b>
					                    </Button>
					                  </ThemeProvider>
					                </Grid>
								</Grid>
					          <ColoredLine color="gray"/>
							</Grid>
		             		<Grid item>
		             			<div style={{textAlign: 'left'}}>
									{ categories.tree.map((item) => (
										<TreeView
										  key={item.id}
									      defaultCollapseIcon={<ExpandMoreIcon />}
									      defaultExpandIcon={<ChevronRightIcon />}>
									      { renderTree(item) }
									    </TreeView>
					        		))}
				        		</div>
			                </Grid>
			                <Grid item xs={true} >
								{ category ? (
									<Grid container>
										<Grid item xs={false} lg={2}/>
										<Grid item xs={12} lg={8}>
											<Grid container spacing={2}>
												<Grid item xs={12}>
													<Grid container>
														<Grid item xs={true}/>
														<Grid item>
															<ImageListItem style={{ justifyContent: 'center'}} >
																{ category.defaultImage || category.iconData ? (
																<div>
																	{ category.defaultImage ? (
											                      	<Image 
									                                  url={service.api.getIconUrl(category.id)} 
									                                  containerProps={{style:{height: '100%'}}}
									                                  imgProps={{ className: style.selectable, style:{ width: 150, height: 150, objectFit: 'cover'}}}
									                                />):(
																		<img src={imageBlob} style={{ width: 150, height: 150, objectFit: 'cover' }} alt=""/>
									                                )}
												                    <ImageListItemBar
												                      actionIcon={
												                        <IconButton disabled={saving || deleting} sx={{ color: 'rgba(255, 255, 255, 0.54)' }}>
												                          <DeleteOutlineIcon fontSize={"small"} onClick={cleanImage}/>
												                        </IconButton>
												                      }
												                    />
											                    </div>):(
											                    <div>
										                    		<ThemeProvider theme={theme}>
																		<Button
												       						disabled={saving || deleting}
																			startIcon={<UploadIcon/>}
																			variant="contained"
																			onClick={imageButtonClick}>
																			<input type='file' accept="image/svg+xml" id='file' ref={inputFile} style={{display: 'none'}} onChange={onSelectFile}/>
																			Cargar imagen
																		</Button>
																	</ThemeProvider>
											                    </div>
											                   	)}
											                </ImageListItem>
														</Grid>	
														<Grid item xs={true}/>
													</Grid>
												</Grid>
												<Grid item xs={12}>
													<TextField
														required
														variant="outlined"
														id="name"
														label="Titulo"
														name="title"
														onChange={onChangeTitle}
												       	disabled={saving || deleting}
														value={title}
														fullWidth
														placeholder="Nombre de categoría"/>
												</Grid>
												<Grid item xs={12}>
													<TextField
														required
														variant="outlined"
														id="name"
														label="Nombre"
														name="name"
														onChange={onChangeName}
												       	disabled={saving || deleting}
														value={name}
														fullWidth
														placeholder="Nombre"/>
												</Grid>
												<Grid item xs={12}>
													<Autocomplete 
										          		options={categories.list}
												       	disabled={saving || deleting}
												        renderInput={(params) => <TextField required {...params} label="Categoría padre" />} 
												        value={parent}
												        onChange={onChangeParent}
												    />
												</Grid>
												<Grid item xs={12}>
													<ColoredLine color="gray" marginBottom={4}/>
												</Grid>
												<Grid item>
													<LoadingButton
														disabled={!category.id || saving}
											            loadingPosition="start"
											            startIcon={<CancelIcon />}
											            loading={deleting}
											            color="error"
											            variant="contained"
											            onClick={remove}>
											            <b>Borrar</b>
									          		</LoadingButton>
												</Grid>
												<Grid item xs={true}/>
												<Grid item>
													<LoadingButton
														disabled={!category.isValid() || deleting}
											            loadingPosition="start"
											            startIcon={<DoneIcon />}
											            loading={saving}
											            variant="contained"
											            onClick={onSaveClick}>
											            <b>{ category.id ? "Guardar" : "Crear" }</b>
									          		</LoadingButton>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={false} lg={2}/>
									</Grid>
								) : (
									null
								)}
			                </Grid>
		                </Grid>
	         			
	             	</Grid>
					<Grid item xs={false} md={2} />
				</Grid>
			)}
		</div>
	)

}